import { FC, ReactNode } from "react";

import { ClientSelector } from "./ClientSelector";
import { useTenantClientSelector } from "./useTenantClientSelector";

import { Popover, PopoverTrigger } from "@/components/ui/v2/popover";

type ClientSelectorTriggerProps = {
  trigger: ReactNode;
};

const ClientSelectorTrigger: FC<ClientSelectorTriggerProps> = ({
  trigger,
}) => {
  const { open, setOpen } = useTenantClientSelector();

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>{trigger}</PopoverTrigger>
      <ClientSelector
        open={open}
        onOpenChange={setOpen}
      />
    </Popover>
  );
};

export { ClientSelectorTrigger };
